
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetogoacabs() {



    const cardData =
    {
        keyword: ' Pune to Goa Cabs',
        heading: 'Mauli Cabs:  Pune to Goa Cabs',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Goa cab services, ensuring a relaxed and enjoyable journey to the vibrant beaches and scenic beauty of Goa. Whether you are traveling with friends, family, or planning a solo trip, we provide a wide range of vehicles including sedans, SUVs, and premium cabs to suit your travel needs. With professional drivers, transparent pricing, no hidden charges, and a strong commitment to punctuality and customer satisfaction, Mauli Cabs guarantees a smooth and memorable ride from Pune to Goa.',

        top: 'Top Places to Visit in Goa with Mauli Cabs',

"topPlaces": [
    {
        "title": "Basilica of Bom Jesus",
        "description": "A UNESCO World Heritage site, the Basilica of Bom Jesus is one of the oldest churches in India. It is renowned for housing the mortal remains of St. Francis Xavier and is an architectural masterpiece of baroque style."
    },
    {
        "title": "Anjuna Beach",
        "description": "Anjuna Beach is famous for its vibrant nightlife, stunning sunsets, and beautiful beach parties. It's also known for its lively flea market, where visitors can shop for a variety of goods ranging from clothes to jewelry."
    },
    {
        "title": "Dudhsagar Waterfalls",
        "description": "Located on the Mandovi River, Dudhsagar Waterfalls is one of the tallest waterfalls in India. Surrounded by lush forests, it offers a picturesque view and is a popular spot for trekking and photography."
    },
    {
        "title": "Fort Aguada",
        "description": "Built by the Portuguese in the 17th century, Fort Aguada offers breathtaking views of the Arabian Sea. The fort also has a lighthouse and is a significant historical site in Goa."
    },
    {
        "title": "Palolem Beach",
        "description": "Known for its crescent-shaped beach, Palolem Beach is a peaceful getaway perfect for swimming, sunbathing, and kayaking. Its serene ambiance and beauty make it one of the most popular beaches in Goa."
    },
    {
        "title": "Se Cathedral",
        "description": "The Se Cathedral is one of the largest churches in Asia and is an important religious site in Goa. It is known for its stunning Portuguese-Gothic architecture and beautiful interior, making it a must-visit for architecture enthusiasts."
    },
    {
        "title": "Vasco da Gama",
        "description": "Named after the famous Portuguese explorer, Vasco da Gama is a vibrant town offering a mix of beaches, markets, and heritage sites. It is known for its colonial-style architecture and is a good base for exploring Goa."
    },
    {
        "title": "Colva Beach",
        "description": "Located in South Goa, Colva Beach is a long stretch of sandy shoreline surrounded by palm trees. It is perfect for leisurely walks, relaxing by the sea, or enjoying water sports like jet skiing and parasailing."
    },
    {
        "title": "Chapora Fort",
        "description": "Chapora Fort is a popular historical site in Goa, known for its strategic location and beautiful panoramic views of the Arabian Sea. It’s famously featured in Bollywood movies, including 'Dil Chahta Hai.'"
    },
    {
        "title": "The Fontainhas",
        "description": "Fontainhas is a charming Latin Quarter in Panjim, Goa. Known for its colorful Portuguese-style houses and narrow streets, it offers a glimpse into Goa's colonial past and is perfect for a walking tour."
    }
],

"services": [
    {
      "name": "Pune to Goa Cab Service",
      "description": "Enjoy a smooth and scenic journey from Pune to Goa with our premium cab service. We offer reliable, door-to-door transportation with multiple vehicle options including sedans, SUVs, and luxury cars. Ideal for leisure, business, or family trips."
    },
    {
      "name": "Pune to Goa Cab Booking",
      "description": "Easily book your cab from Pune to Goa online or via phone. Choose your preferred travel date, vehicle type, and route, with options for one-way or round-trip bookings. Hassle-free confirmations and 24/7 customer support available."
    },
    {
      "name": "Pune to Goa Rental Cabs",
      "description": "Hire rental cabs for your Pune to Goa trip with flexible hourly or per-day pricing. Enjoy clean, well-maintained vehicles and professional drivers to make your coastal getaway comfortable and convenient."
    },
    {
      "name": "Pune to Goa One-Way Cab",
      "description": "Looking for a one-way cab from Pune to Goa? Our service offers affordable point-to-point transfers without return fare charges. Ideal for solo travelers, students, or anyone planning a one-way trip."
    },
    {
      "name": "Pune to Goa Round Trip Cabs",
      "description": "Plan a Pune-Goa-Pune round trip with our competitively priced round-trip cab services. Great for weekend getaways and long holidays with the benefit of retaining the same driver and vehicle throughout your journey."
    },
    {
      "name": "Pune to Goa Luxury Taxi",
      "description": "Travel in style with our luxury taxi service from Pune to Goa. Enjoy high-end vehicles like Innova Crysta, BMW, or Audi for a premium experience, complete with refreshments, Wi-Fi, and executive service."
    },
    {
      "name": "Pune to Goa Cabs",
      "description": "Find a wide range of cabs for your Pune to Goa travel needs. Whether it's economy travel or luxury rides, our fleet is ready to make your journey memorable and stress-free."
    },
    {
      "name": "Pune to Goa Car Rental",
      "description": "Rent a self-drive or chauffeur-driven car for your Pune to Goa trip. Various car types including hatchbacks, sedans, and SUVs are available for flexible rental durations."
    },
    {
      "name": "Pune to Goa Taxi",
      "description": "Book a reliable taxi from Pune to Goa with professional drivers, clean vehicles, and GPS tracking. We ensure safety, comfort, and timely arrivals."
    },
    {
      "name": "Pune to Goa Taxi Fare",
      "description": "Check transparent taxi fare details for Pune to Goa travel. We offer fixed, all-inclusive pricing with no hidden charges—pay what you see."
    },
    {
      "name": "Pune to Goa Cab Package",
      "description": "Avail curated Pune to Goa cab packages that include sightseeing, hotel pickups, and multi-day tours. Ideal for tourists seeking value and ease."
    },
    {
      "name": "Pune to Goa Cab Fare",
      "description": "Know your cab fare in advance for Pune to Goa trips. We provide upfront pricing based on vehicle type and travel date with zero surge pricing."
    },
    {
      "name": "Best Cab Service from Pune to Goa",
      "description": "Experience the best-rated cab service from Pune to Goa. Trusted by thousands of customers for punctuality, cleanliness, driver behavior, and vehicle comfort."
    },
    {
      "name": "Cab Service from Pune to Goa",
      "description": "Get dependable cab service from Pune to Goa with instant booking, on-time pickups, and courteous drivers. Suitable for individual travelers and groups alike."
    },
    {
      "name": "Car Hire Pune to Goa",
      "description": "Hire cars from Pune to Goa for short or long-term use. Our car hire service provides a wide range of options with competitive pricing and flexible pick-up schedules."
    },
    {
      "name": "One Way Cab from Pune to Goa",
      "description": "Affordable one-way cabs available from Pune to Goa with multiple vehicle options and experienced drivers. No need to pay return fare—ideal for single-leg journeys."
    },
    {
      "name": "Pune Goa Cab Service",
      "description": "Trusted cab service for Pune to Goa route, featuring air-conditioned vehicles, verified drivers, and real-time tracking for complete peace of mind."
    },
    {
      "name": "Pune to Goa Cab Cost",
      "description": "Understand your Pune to Goa cab cost in detail. We offer competitive rates based on fuel prices, tolls, and distance to ensure budget-friendly travel."
    },
    {
      "name": "Pune to Goa Cab Charges",
      "description": "Explore detailed cab charges for Pune to Goa rides. Charges vary by vehicle category and service type—economy, executive, or luxury."
    },
    {
      "name": "Pune to Goa Cab Rental",
      "description": "Flexible cab rental services for Pune to Goa including daily rentals, one-way, and round-trip packages. Book ahead and save more."
    },
    {
      "name": "Pune to Goa Cab Service Fare",
      "description": "Get a full breakdown of service fares for Pune to Goa travel. Our fare policy is fully transparent, including driver allowance, tolls, and night charges if applicable."
    },
    {
      "name": "Pune to Goa Cab Service Rates",
      "description": "Check standard rates for Pune to Goa cab services across vehicle types. Includes base fare, extra distance rate, and any applicable taxes."
    },
    {
      "name": "Pune to Goa Innova Rental",
      "description": "Rent an Innova or Innova Crysta from Pune to Goa for comfortable and spacious travel. Ideal for groups, families, or long-distance road trips."
    },
    {
      "name": "Pune to Goa One Way Taxi",
      "description": "Save on costs with our one-way taxi service from Pune to Goa. Get a private ride with no return fare obligation."
    },
    {
      "name": "Pune to Goa Taxi Service",
      "description": "Get professional taxi service from Pune to Goa with trained drivers, clean vehicles, and real-time booking confirmations."
    }
  ],
  "tableData": [
    ["Pune to Goa Cab Service", "Pune to Goa Cab Booking"],
    ["Pune to Goa Rental Cabs", "Pune to Goa One-Way Cab"],
    ["Pune to Goa Round Trip Cabs", "Pune to Goa Luxury Taxi"],
    ["Pune to Goa Cabs", "Pune to Goa Car Rental"],
    ["Pune to Goa Taxi", "Pune to Goa Taxi Fare"],
    ["Pune to Goa Cab Package", "Pune to Goa Cab Fare"],
    ["Best Cab Service from Pune to Goa", "Cab Service from Pune to Goa"],
    ["Car Hire Pune to Goa", "One Way Cab from Pune to Goa"],
    ["Pune Goa Cab Service", "Pune to Goa Cab Cost"],
    ["Pune to Goa Cab Charges", "Pune to Goa Cab Rental"],
    ["Pune to Goa Cab Service Fare", "Pune to Goa Cab Service Rates"],
    ["Pune to Goa Innova Rental", "Pune to Goa One Way Taxi"],
    ["Pune to Goa Taxi Service", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Scenic and Comfortable Journey",
        "WhyChoosedescription": "Enjoy the scenic drive from Pune to Goa in our clean, air-conditioned cabs. Whether it’s the lush Western Ghats or coastal views, Mauli Cabs ensures a relaxing and enjoyable ride throughout your trip."
    },
    {
        "WhyChooseheading": "Multiple Vehicle Options",
        "WhyChoosedescription": "Choose from a range of vehicles including sedans, SUVs, and tempo travelers based on your group size and travel comfort. We have options suited for solo travelers, families, and large groups."
    },
    {
        "WhyChooseheading": "Experienced Long-Distance Drivers",
        "WhyChoosedescription": "Our drivers are trained for long highway routes and are well-acquainted with the Pune to Goa journey. They ensure a smooth, safe, and timely travel experience even on extended trips."
    },
    {
        "WhyChooseheading": "One-Way and Round-Trip Flexibility",
        "WhyChoosedescription": "Mauli Cabs offers both one-way drops and round-trip cab packages from Pune to Goa. Plan your trip your way, with flexible return dates and stops along the route if desired."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "No hidden charges—get affordable, all-inclusive fares for your Pune to Goa cab. Our pricing is transparent and ensures you get premium service at reasonable rates."
    },
    {
        "WhyChooseheading": "24/7 Travel Availability",
        "WhyChoosedescription": "Heading to Goa for a weekend or late-night party? We’re available round-the-clock to accommodate your travel needs, no matter the time or day."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop",
        "WhyChoosedescription": "Enjoy the convenience of pickup from your home or hotel in Pune and drop at your preferred location in Goa—be it a beach resort, guest house, or city center."
    },
    {
        "WhyChooseheading": "Safety and Hygiene First",
        "WhyChoosedescription": "Our cabs are sanitized before every ride, GPS-enabled, and driven by background-verified professionals. Travel with peace of mind and full safety from Pune to Goa."
    }
]



















    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Goa with Mauli Cabs?',
            answer: 'You can book a Pune to Goa cab easily through our website or mobile app. Just enter "Pune" as your pickup and "Goa" as your drop location, choose your preferred cab type, and confirm the booking. You can also reach out to our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Goa trip?',
            answer: 'Mauli Cabs offers multiple vehicle options including Hatchbacks, Sedans, SUVs, Ertiga, and Innova Crysta for the Pune to Goa route. Choose based on your comfort needs and number of passengers.',
        },
        {
            question: 'Is the fare from Pune to Goa fixed or does it vary?',
            answer: 'We provide fixed and transparent pricing for Pune to Goa trips. The fare includes tolls, taxes, fuel, and driver allowance. There are no hidden charges, and you’ll see the full fare at the time of booking.',
        },
        {
            question: 'How long does the journey from Pune to Goa take?',
            answer: 'The Pune to Goa drive usually takes around 8 to 10 hours depending on the route and traffic conditions. We suggest starting early for a smoother and more scenic journey.',
        },
        {
            question: 'Can I book a round trip from Pune to Goa?',
            answer: 'Yes, round trip options are available. You can choose your return date and time at the time of booking or modify it later through our app or by contacting customer service.',
        },
        {
            question: 'Are night trips available from Pune to Goa?',
            answer: 'Yes, we operate 24/7, and you can schedule a day or night journey as per your preference. Our drivers are trained for long-distance travel and ensure safe travel at any time.',
        },
        {
            question: 'Can I make stops along the way during my Pune to Goa trip?',
            answer: 'Absolutely! You can request stops for meals, breaks, or sightseeing. Just inform the driver or mention your preferences during booking, and we’ll plan the route accordingly.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Ajay Patil",
            position: "Vacation Traveler",
            text: "I booked Mauli Cabs for my Goa trip from Pune and had a wonderful experience. The car was spacious, the ride was smooth, and the driver was very cooperative. Would definitely book again!",
            image: "/img/testimonial/testimonial-thumb-1-5.png",
        },
        {
            name: "Miss. Rutuja Khedekar",
            position: "Student",
            text: "We went on a college trip to Goa and booked an Innova through Mauli Cabs. The service was punctual, affordable, and super comfortable. Highly recommend it for group travel.",
            image: "/img/testimonial/testimonial-thumb-1-6.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Goa Cab Service by Mauli Cabs",
        "description": "Mauli Cabs offers reliable and affordable cab services from Pune to Goa. Choose from one-way, round-trip, or luxury cabs including Innova, Sedan, and rental packages. Enjoy a comfortable ride with 24x7 online booking for beach getaways and holiday trips.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "6700"
        }
      };
      
      
      

    return (
        <div>
            <GTag/>

<Helmet>
        <title>Pune to Goa Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Goa cab with Mauli Cabs. Choose from affordable rental cabs, luxury cars, one-way or round-trip taxi services. Innova, sedan, and SUV options available for your Goa vacation. 24x7 online booking and reliable service."
        />
        <meta
          name="keywords"
          content="Pune to Goa Cab Service, Pune to Goa Cab Booking, Pune to Goa Rental Cabs, Pune to Goa one-way cab, Pune to Goa Round Trip Cabs, Pune to Goa Luxury Taxi, pune to goa cabs, Pune to Goa Car Rental, Pune to Goa Taxi, Pune to Goa Taxi fare, Pune to Goa Cab Package, Pune to Goa cab fare, Best cab service from pune to Goa, Cab service from pune to Goa, Car Hire Pune to Goa, One way cab from pune to Goa, Pune Goa Cab Service, Pune to Goa Cab Cost, pune to goa cab charges, Pune to goa cab booking, pune to goa cab rental, Pune to goa cab service fare, Pune to goa cab service rates, Pune to Goa Innova Rental, Pune to Goa one way cab, Pune to Goa one way taxi, Pune to goa taxi service"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>


            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/55.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogoacabs;